import styled from 'styled-components'

export const StepTrackerContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`

export const ProgressBarContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  height: 16px;
  min-width: 40px;
`

export const TextContainer = styled(SpinnerContainer)`
  justify-content: right;
`

export const StepText = styled.p`
  font-family: 'EBGaramond', sans-serif;
  font-size: 16px;
  margin: 0;
`
